var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 2.49864C15.0799 1.49973 14.1119 0.531744 13.113 0.893693L0.904537 5.30898C-0.097721 5.67176 -0.218928 7.03931 0.703082 7.57346L4.6001 9.82959L8.08 6.34969C8.23765 6.19742 8.44881 6.11316 8.66798 6.11507C8.88715 6.11697 9.09681 6.20488 9.2518 6.35987C9.40678 6.51485 9.49469 6.72451 9.4966 6.94368C9.4985 7.16286 9.41425 7.37401 9.26198 7.53166L5.78208 11.0116L8.03904 14.9086C8.57235 15.8306 9.9399 15.7086 10.3027 14.7071L14.7188 2.49864Z",
    fill: "#005CEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e10412880017a511e41ea7212e7fa4f1.svg";
export { ForwardRef as ReactComponent };